module.exports = __webpack_public_path__ + "img/YAMAHA.fa1c3ed.jpg";